import { ContextHelp } from '../components/common/help/help.dtos';
import { createAction, createReducer, on, props } from '@ngrx/store';

export const SET_CONTEXTHELP = createAction('SET_CONTEXTHELP', props<{ context: ContextHelp }>());
export const DELETE_CONTEXTHELP = createAction('DELETE_CONTEXTHELP');

const initialState = {} as ContextHelp;

const _contextHelpReducer = createReducer(
  initialState,
  on(SET_CONTEXTHELP, (state, { context }) => context),
  on(DELETE_CONTEXTHELP, (state) => initialState)
);

export function contextHelpReducer(state, action) {
  return _contextHelpReducer(state, action);
}
